import React from 'react';

import { Card } from '@material-ui/core';

const CustomCard = ({ children, elevation = 4 }) => {
  return <Card elevation={elevation}>{children}</Card>;
};

export default CustomCard;
